import {
  ModalProvider,
  ModalConsumer,
} from 'packages/modal/components/ModalPovider';
import ModalRender from 'packages/modal/components/ModalRender';
import withModal from 'packages/modal/components/withModal';

export { ModalProvider, ModalRender, ModalConsumer };
export default withModal;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/modal/index.js